import {create} from 'zustand';
export interface weekHoursProps {
    name: string,
    startAM: string,
    endAM: string,
    startPM: string,
    endPM: string,
    hours?: number,
    day: number,
  }

interface StaffState {
    formData: Record<string, any>;
    setFormData: (formData: Record<string, any>) => void;

    clientName: string;
    setClientName: (clientName: string) => void;

    viewOrUpdate : string;
    setViewOrUpdate: (viewOrUpdate: string) => void;

    users: any[];
    setUsers: (users: any[]) => void;

    idUser: number;
    setIdUser: (idUser: number) => void;

    weekHours: weekHoursProps[];
    setWeekHours: (weekHours: any) => void;

    dataFilterUsers: any[];
    setDataFilterUsers: (dataFilterUsers: any[]) => void;

    dataFilterEvents: any[];
    setDataFilterEvents: (dataFilterEvents: any[]) => void;

    tabStaff: string;
    setTabStaff: (tabStaff: string) => void;

    idsUsers: number[];
    setIdsUsers: (idsUsers: number[]) => void;

    libelles: any[];
    setLibelles: (libelles: any[]) => void;

    events: any[];
    setEvents: (events: any[]) => void;

    idEvent: number;
    setIdEvent: (idEvent: number) => void;

    updateStaff: boolean;
    setUpdateStaff: (updateStaff: boolean) => void;

    resetStaff: () => void;
};

export const useStaffStore = create<StaffState>((set) => ({
    formData: {},
    setFormData: (formData) => set({formData}),

    clientName: '',
    setClientName: (clientName) => set({clientName}),

    users: [],
    setUsers: (users) => set({users}),
    
    viewOrUpdate: '',
    setViewOrUpdate: (viewOrUpdate) => set({viewOrUpdate}),

    idUser: 0,
    setIdUser: (idUser) => set({idUser}),

    dataFilterUsers: [],
    setDataFilterUsers: (dataFilterUsers) => set({dataFilterUsers}),

    dataFilterEvents: [],
    setDataFilterEvents: (dataFilterEvents) => set({dataFilterEvents}),

    idsUsers: [],
    setIdsUsers: (idsUsers) => set({idsUsers}),

    weekHours: [{
        name: "Lundi",
        startAM: "00:00",
        endAM: "00:00",
        startPM: "00:00",
        endPM: "00:00",
        hours: 0,
        day: 1,
      },
      {
        name: "Mardi",
        startAM: "00:00",
        endAM: "00:00",
        startPM: "00:00",
        endPM: "00:00",
        hours: 0,
        day: 2,
      },
      {
        name: "Mercredi",
        startAM: "00:00",
        endAM: "00:00",
        startPM: "00:00",
        endPM: "00:00",
        hours: 0,
        day: 3,
      },
      {
        name: "Jeudi",
        startAM: "00:00",
        endAM: "00:00",
        startPM: "00:00",
        endPM: "00:00",
        hours: 0,
        day: 4,
      },
      {
        name: "Vendredi",
        startAM: "00:00",
        endAM: "00:00",
        startPM: "00:00",
        endPM: "00:00",
        hours: 0,
        day: 5,
      },
      {
        name: "Samedi",
        startAM: "00:00",
        endAM: "00:00",
        startPM: "00:00",
        endPM: "00:00",
        hours: 0,
        day: 6,
      },
      {
        name: "Dimanche",
        startAM: "",
        endAM: "",
        startPM: "",
        endPM: "",
        hours: 0,
        day: 0,
      },],
    setWeekHours: (weekHours) => set({weekHours}),

    tabStaff:"Utilisateurs",
    setTabStaff: (tabStaff) => set({tabStaff}),

    libelles: [],
    setLibelles: (libelles) => set({libelles}),

    events: [],
    setEvents: (events) => set({events}),

    idEvent: 0,
    setIdEvent: (idEvent) => set({idEvent}),

    updateStaff: false,
    setUpdateStaff: (updateStaff) => set({updateStaff}),

    resetStaff: () => set({
      formData: {},
      clientName: '',
      users: [],
      idUser: 0,
      weekHours: [{
        name: "Lundi",
        startAM: "00:00",
        endAM: "00:00",
        startPM: "00:00",
        endPM: "00:00",
        hours: 0,
        day: 1,
      },
      {
        name: "Mardi",
        startAM: "00:00",
        endAM: "00:00",
        startPM: "00:00",
        endPM: "00:00",
        hours: 0,
        day: 2,
      },
      {
        name: "Mercredi",
        startAM: "00:00",
        endAM: "00:00",
        startPM: "00:00",
        endPM: "00:00",
        hours: 0,
        day: 3,
      },
      {
        name: "Jeudi",
        startAM: "00:00",
        endAM: "00:00",
        startPM: "00:00",
        endPM: "00:00",
        hours: 0,
        day: 4,
      },
      {
        name: "Vendredi",
        startAM: "00:00",
        endAM: "00:00",
        startPM: "00:00",
        endPM: "00:00",
        hours: 0,
        day: 5
      },
      {
        name: "Samedi",
        startAM: "00:00",
        endAM: "00:00",
        startPM: "00:00",
        endPM: "00:00",
        hours: 0,
        day: 6,
      },
      {
        name: "Dimanche",
        startAM: "",
        endAM: "",
        startPM: "",
        endPM: "",
        hours: 0,
        day :0,
      },],
      dataFilterUsers: [],
      dataFilterEvents: [],
      idsUsers: [],
      viewOrUpdate: '',
      libelles: [],
      events: [],
    })
}));